import { useNavigate } from 'react-router';
import { buildScopedSearch, useAsyncResource } from '@hooks';
import { getAssetInspections } from '@/entities/asset/assetInspection.api';
import { mapDate, summarizeAssetInspections } from './map.model';
import styles from './MapSelectionCard.module.css';

function AssetInspectionSummary({ companyId, row }) {
  const resource = useAsyncResource(async () => summarizeAssetInspections(
    await getAssetInspections(companyId, row.siteId, row.assetId)
  ), [companyId, row.siteId, row.assetId], { initialData: null });
  if (resource.isLoading) return <p role="status">Loading inspection summary…</p>;
  if (resource.error) return <p>Inspection summary unavailable. <button type="button" className={styles.link}
    onClick={() => resource.reload()}>Retry summary</button></p>;
  return resource.data && <p>Recorded methods: <strong>{resource.data.techniques}</strong>
    {' '}· Latest inspection record: <strong>{resource.data.lastInspection}</strong></p>;
}

export default function MapSelectionCard({ companyId, row, onBrowseAssets }) {
  const navigate = useNavigate();
  if (!row) return <section className={styles.empty}><h3>Select a location</h3>
    <p>Choose a result or a pin to see its context and open related records.</p></section>;

  function open(path, params = {}) {
    const query = buildScopedSearch('', { siteId: row.siteId, assetId: row.assetId || null }, params);
    navigate({ pathname: path, search: query ? '?' + query : '' });
  }
  return <section className={styles.card} aria-label="Selected location">
    <div className={styles.heading}>
      <div><span>{row.mode === 'assets' ? 'SELECTED ASSET' : 'SELECTED SITE'}</span>
        <h3>{row.label}</h3><p>{row.mode === 'assets' ? row.siteLabel + ' · ' : ''}{row.assetId || row.siteId}</p>
      </div>
      <span className={styles.status} data-tone={row.healthTone}>{row.health}</span>
    </div>
    <div className={styles.metadata}>
      <p>Last inspection in catalogue: <strong>{mapDate(row.lastInspection)}</strong></p>
      {!row.coordinates && <p className={styles.warning}>No valid coordinates are recorded. This location remains available in the list.</p>}
      {row.mode === 'assets' && <AssetInspectionSummary key={JSON.stringify([companyId, row.id])} companyId={companyId} row={row} />}
    </div>
    <div className={styles.actions}>
      {row.mode === 'sites' && <button type="button" onClick={() => onBrowseAssets(row)}>Browse assets</button>}
      <button type="button" onClick={() => open('/iod')}>Components</button>
      <button type="button" onClick={() => open('/anomaly-suite', { anomalyView: 'register' })}>Anomalies</button>
      <button type="button" onClick={() => open('/report-browser')}>Reports</button>
      <button type="button" onClick={() => open('/inspection-suite')}>Inspections</button>
      {row.mode === 'assets' && <button type="button" onClick={() => open('/anomaly-suite', { anomalyView: 'viewer' })}>3D viewer</button>}
    </div>
  </section>;
}